import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from 'react'
import logo from '../../images/whitelogo.png'
import { useDispatch, useSelector } from "react-redux";
import { getProfiledata } from "../../Store/ProdataAction";
const Header = () => {
    const [show, setShow] = useState(false)
const dropdownRef = useRef(null);
    const prodata = useSelector((state) => state.ProData.profiledata);

    const dispatch = useDispatch()

const navigate = useNavigate()
    useEffect(() => {
        dispatch(getProfiledata())
    }, [])


useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShow(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, []);

    return (
        <header>
            <div class="container">
                <div class="header-data d-flex align-items-center justify-content-between">
                    <div class="logo">
                        <Link to='/' title=""><img src={logo} alt="" /></Link>
                    </div>
                    {/* <div class="search-bar">
                        <form>
                            <input type="text" name="search" placeholder="Search..." />
                            <button type="submit"><i class="la la-search"></i></button>
                        </form>
                    </div> */}
                    <nav>
                        <ul>
                            <li>
                                <Link to="/" title="">
                                    <i class="las la-home d-block"></i>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/talentscore" title="">
                                    <i class="las la-chart-pie d-block"></i>
                                    Talent Score
                                </Link>

                            </li>
                            <li>
                                <Link to="/myclub" title="">
                                    <i class="las la-building d-block"></i>
                                    My Group
                                </Link>
                            </li>
                          {/* <li>
                            <Link to="/addclub" title="">
                                <i className="las la-plus-circle me-2"></i>
                                <span>Add Clubs</span>
                            </Link>
                            </li> */}
                            <li>
                                <Link to="/offer" title="">
                                    <i class="las la-tag d-block"></i>
                                    Todays Offer
                                </Link>

                            </li>

                            <li>
                                <Link to="/bucketlist" title="" class="not-box-openm">
                                    <i class="las la-briefcase d-block"></i>
                                    My Bucket List
                                </Link>

                            </li>

                        </ul>
                    </nav>
                    <div class="menu-btn">
                        <Link href="#" title=""><i class="fa fa-bars"></i></Link>
                    </div>

                    {prodata.map((item) => {
                        return (
                            <div class="user-account "  ref={dropdownRef}  style={{ width: "170px" }}>
                               <div className="user-info d-flex align-items-center" onClick={() => setShow(!show)}>

    <div className="comment-img d-flex align-items-center justify-content-center rounded-circle text-white"
        style={{ width: "40px", height: "40px", overflow: "hidden" }}>

        {item.profile_image ? (
            <img
                src={`https://thetalentclub.co.in/upload/profile/${item.profile_image}`}
                alt="profile"
                className="img-fluid rounded-circle"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
        ) : (
            <span className="fw-bold">
                {item.firstname?.charAt(0).toUpperCase()}
                {item.lastname?.charAt(0).toUpperCase()}
            </span>
        )}

    </div>

    <Link to="/" title="" className="mx-2">
        {item.firstname}
    </Link>

    <i className="la la-sort-down"></i>

</div>

                                <div class={show ? "user-account-settingss d-block" : "user-account-settingss"} id="users">

                                    <h3>Setting</h3>
                                    <ul class="us-links px-2">
                                        <li><Link to="/setting" onClick={()=>setShow(false)} title="">Account Setting</Link></li>
                                        <li><Link to="/"  onClick={()=>setShow(false)} title="">Privacy</Link></li>
                                        <li><Link to="/"  onClick={()=>setShow(false)} title="">Faqs</Link></li>
                                        <li><Link to="/"   onClick={()=>setShow(false)} title="">Terms & Conditions</Link></li>
                                    </ul>
                                    <h3 class="tc" style={{cursor:"pointer"}}  onClick={()=>{
                                        localStorage.removeItem(`user_id`)
                                        localStorage.removeItem(`user_loggedin`)
                                        navigate('/log')
                                    }}>Logout</h3>
                                </div>
                            </div>
                        )
                    })}

                    <Link to="/searchpage/:id">
                        <i class="fa-solid fa-magnifying-glass text-light"></i>
                    </Link>




                </div>
            </div>
        </header>
    )
}

export default Header
